import React from 'react';
import { RadialBarChart, RadialBar, Legend, ResponsiveContainer, Tooltip } from 'recharts'; // We might use Recharts later

const ReadinessDashboard = ({ data }) => {
  if (!data) return null;

  const { score, emoji, percentage, indicators, injuryRiskScore, injuryRiskLevel, volumeConsistencyScore, activityStreak } = data;

  // Visual Gauge helper (simple CSS based for now)
  const getGaugeColor = (val) => {
     if (val >= 80) return 'text-green-500 border-green-500';
     if (val >= 60) return 'text-yellow-500 border-yellow-500';
     return 'text-red-500 border-red-500';
  };
  
  const gaugeColor = getGaugeColor(parseInt(percentage));

  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700 h-full flex flex-col">
        <h3 className="text-gray-400 text-xs uppercase tracking-wider mb-4">Daily Readiness</h3>
        
        <div className="flex items-center justify-center py-4 mb-4 relative">
             {/* Circular Gauge Placeholder */}
             <div className={`w-32 h-32 rounded-full border-8 flex flex-col items-center justify-center ${gaugeColor} bg-gray-900`}>
                 <span className="text-3xl font-bold text-white">{score}</span>
                 <span className="text-xs text-gray-400">/ 10</span>
             </div>
             
             {/* Status Badge */}
             <div className="absolute bottom-2 bg-gray-800 px-3 py-1 rounded-full border border-gray-600 shadow-lg flex items-center gap-1">
                 <span>{emoji}</span>
                 <span className="text-sm font-medium text-white">
                     {score >= 8 ? "Prime" : score >= 6 ? "Caution" : "Rest Needed"}
                 </span>
             </div>
        </div>

        {/* Indicators List */}
        <div className="space-y-2 flex-grow">
            {indicators && indicators.length > 0 ? (
                indicators.map((ind, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm text-gray-300 bg-gray-700/30 p-2 rounded">
                         <span className={ind.status === 'positive' ? 'text-green-400' : 'text-red-400'}>
                             {ind.status === 'positive' ? '✓' : '⚠'}
                         </span>
                         <span>{ind.text}</span>
                    </div>
                ))
            ) : (
                <p className="text-gray-500 text-sm text-center">No specific warnings.</p>
            )}
        </div>
        
        {/* Secondary Metrics */}
        <div className="grid grid-cols-2 gap-3 mt-4 pt-4 border-t border-gray-700">
             <div className="text-center">
                 <p className="text-xs text-gray-500">Injury Risk</p>
                 <p className={`font-bold ${injuryRiskScore < 30 ? 'text-green-400' : injuryRiskScore < 60 ? 'text-yellow-400' : 'text-red-400'}`}>
                     {injuryRiskLevel} ({injuryRiskScore}%)
                 </p>
             </div>
             <div className="text-center">
                 <p className="text-xs text-gray-500">Consistency</p>
                 <p className="font-bold text-blue-400">
                     {volumeConsistencyScore.toFixed(1)} / 5.0
                 </p>
             </div>
        </div>
    </div>
  );
};

export default ReadinessDashboard;
